var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleClass,style:(_vm.mapStyle),attrs:{"id":"map"}},[(!_vm.status)?_c('span',{style:(_vm.defaultTextStyle)},[_vm._v(_vm._s(_vm.defaultText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }